<template>
  <div class="flock-card-footer half-pixel-bottom-border">
    <!-- 评论 -->
    <template v-if="info.comment_counts >= 10">
      <img class="flock-card-footer-comment" src="../image/comment.png" />
      <div class="flock-card-footer-comment-count">{{info.comment_counts}}</div>
    </template>
    <!-- 赞 -->
    <!-- <img class="flock-card-footer-status" @click.stop="likeClick"  src="../image/up-active.png" /> -->
    <img class="flock-card-footer-status" @click.stop="likeClick" src="../image/up.png" />
    <!-- 热度 -->
    <div class="flock-card-footer-heat-rate" @click.stop>{{formatAgreeCount(info.agree_counts + localLikeStatus)}}</div>
    <!-- 踩 -->
    <!-- <img class="flock-card-footer-status flock-card-footer-status-last"  @click.stop="likeClick" src="../image/down-active.png" /> -->
    <img class="flock-card-footer-status flock-card-footer-status-last" @click.stop="likeClick" src="../image/down.png" />
  </div>
</template>

<script>
export default {
  name: 'FlockCardFooter',
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    localLikeStatus: {
      type: [Number],
      default: 0
    }
  },
  computed: {
    formatAgreeCount () {
      return function (count) {
        if (count < 0) {
          return 0
        }
        if (count > 9999) {
          return '10k+'
        }
        return count
      }
    }
  },
  methods: {
    likeClick () {
      this.$emit('likeClick')
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../mixins.less);

.flock-card-footer{
  .flex();
  .webkitCss(align-items, center);
  .webkitCss(justify-content, flex-end);
  color:rgba(170,170,170,1);
}

.flock-card-footer-comment{
  .square(24 / @ratio);
}

.flock-card-footer-status{
  .square(56 / @ratio);
  padding: 12 / @ratio 0;
}

.flock-card-footer-comment-count{
  .webkitCss(flex, 1 1 auto);
  margin-left: 8 / @ratio;
  font-size:24 / @ratio;
}

.flock-card-footer-heat-rate{
  width: 98 / @ratio;
  font-size:32 / @ratio;
  text-align: center;
}

.flock-card-footer-status-last{
  margin-right: -16 / @ratio;
}
</style>
